// @flow
export { default } from './ActivityMessage';
